import React, { useEffect, useState } from "react";
import { Box, Card, CardContent} from "@mui/material";
import { Button, DateField, FunctionField,  SimpleShowLayout, TopToolbar, useGetOne, useRedirect } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { Link, useParams } from "react-router-dom";
import { getNameAndCompanyNamewithAddress, getResource } from "../common";

const VisitHistoryShow = () => {
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams(); 
  const [customers,setCustomers]=useState([]);
  const redirect = useRedirect();

  const { data, isLoading } = useGetOne("visitHistory", { id });
  useEffect(() => {
    if(!isLoading && data){
      setRecord(data);
    }
  },[data,isLoading]);

  useEffect(() => {
    const getCustomers = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };
    getCustomers();
  }, []);

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, margin: 0 }}>
        <TopToolbar>
            <Button
                label="訪問情報編集"
                onClick={() => redirect(`/visitHistory/${id}`)}
                startIcon={<EditIcon />}
            />
        </TopToolbar>
    </Box>
  );

  const labelStyle = (text) => (
    <div style={{ backgroundColor: "#eee", color: "#666", paddingLeft: "5px" }}>
      {text}
    </div>
  );

  return (
    <>
      <CustomTopToolbar/>
      <Card>
        <CardContent>
          <SimpleShowLayout record={record}>
            {/* <FunctionField source="number" label={labelStyle("訪問No")} style={{ paddingLeft: "5px" }} render={(record) => {
              return String(record.number).padStart(5, "0");
            }}/> */}
            <DateField source="visitDate" label={labelStyle("訪問日")} style={{ paddingLeft: "5px" }} />
            <FunctionField source="content" label={labelStyle("訪問内容")} style={{ paddingLeft: "5px" }} render={record => {return record.content}} />
            <FunctionField source="staffName" label={labelStyle("対応担当者")} style={{ paddingLeft: "5px" }} render={record => {return record.staffName}} />
              <FunctionField
                source="customerId"
                label={labelStyle("顧客名")} style={{ paddingLeft: "5px" }}
                render={(record) => {
                  const customer = customers.find(req => req.id === record.customerId);
                  return customer ? <Link to={`/${getResource(customer)}/show/${record.customerId}`}>{getNameAndCompanyNamewithAddress(customer)}</Link> : "";
                }}
              />
            </SimpleShowLayout>
        </CardContent>
      </Card>
    </>

  );
};

export default VisitHistoryShow;

